import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { MatchesRepository } from "../../api/repositories/stats/matches";
import { NotFoundBlock } from "../components/layout/errors";
import { PageContainer } from "../components/layout/page";
import { Match, MatchPlayerModel } from "../../api/repositories/stats/models/matches";
import { MatchPlayersTableBlock } from "../components/blocks/match/players-table";
import { MatchMetaBlock } from "../components/blocks/match/meta";
import { PicksBlock } from "../components/blocks/match/picks";
import { BuildingsDestroyedBlock } from "../components/blocks/match/builds-destoyed";
import { MapBlock } from "../components/blocks/match/map";
import { LoadingIcon } from "../components/ui/icons";

export const MatchPage: React.FC = () => {
    const { id } = useParams();
    const [response, setResponse] = useState<ApiDataResponse<Match> | undefined>();

    useEffect(() => {
        const repository = new MatchesRepository();

        if (id) {
            const parsedId = parseInt(id);

            if (!isNaN(parsedId)) {
                repository.get(parsedId).then(v => setResponse(v));
            }
        }
    }, [id]);

    const notFoundBlock = <NotFoundBlock
        localText="match_not_found_title"
        onClickBtn={() => window.location.href = '/'}
        btnLocalText="match_not_found_btn"
        withImg={false}
    />

    return (
        <PageContainer
            containerClassName={`mt-[60px]`}
            headerImgPath="/v2/images/bg/towers.png"
            child={
                <div className="max-w-[1561px] mx-auto xl:min-h-screen">
                    {
                        !id || isNaN(parseInt(id))
                            ? notFoundBlock
                            : response
                                ? response.hasErrors
                                    ? notFoundBlock
                                    : <MatchContainer match={response.data!} />
                                : <LoadingIcon />
                    }
                </div>
            }
        />
    );
};

const MatchContainer: React.FC<{
    match: Match
}> = ({ match }) => {
    const blockClassName = 'bg-dark py-[20px] px-[24px] shadow-dark-l '

    return <div className="flex flex-col gap-[24px]">
        <MatchMetaBlock className={blockClassName} meta={match.meta} />
        <MatchPlayersTableBlock matchPlayers={match.players} />
        <div className="flex flex-col lg:flex-row lg:flex-wrap 2xl:flex-nowrap justify-between w-screen max-w-[1561px]  gap-4">
            <PicksBlock className={blockClassName} picks={match.picks} isDuo={match.meta.isDuo} />
            <BuildingsDestroyedBlock className={blockClassName} buildingsDestroyed={match.buildingsDestroyed} />
            <MapBlock className={blockClassName} players={match.players} isDuo={match.meta.isDuo} />
        </div>
    </div>
}

